// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1DGsh","bigColWidth":"Table_bigColWidth__2qqjl","biggerColWidth":"Table_biggerColWidth__3eM1v","row":"Table_row__3CHCn","col":"Table_col__3x3WK"};